(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-stock-status"] && !Shopify.designMode) return;
  try {
    class ProductStockStatus extends HTMLElement {
    connectedCallback() {
      const closestSection = this.closest('.shopify-section, dialog');
      closestSection?.addEventListener('variant:update', this.updateStockStatus);
    }

    disconnectedCallback() {
      const closestSection = this.closest('.shopify-section, dialog');
      closestSection?.removeEventListener('variant:update', this.updateStockStatus);
    }

    updateStockStatus = (event) => {
      if (event.detail.data.newProduct) {
        this.dataset.productId = event.detail.data.newProduct.id;
      } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
        return;
      }

      const blockId = this.dataset.stockStatusBlockId;
      const selector = `product-stock-status[data-stock-status-block-id="${blockId}"]`;
      const newStockStatus = event.detail.data.html.querySelector(selector);

      if (!newStockStatus) return;

      this.innerHTML = newStockStatus.innerHTML;

      const nextText = this.textContent?.trim() ?? '';
      this.toggleAttribute('hidden', nextText.length === 0);
    };
  }

  if (!customElements.get('product-stock-status')) {
    customElements.define('product-stock-status', ProductStockStatus);
  }
  } catch(e) { console.error(e); }
})();

})();
